// 영수증 파라미터 타입 정의
export interface ReceiptParams {
    tid: string
    noTid: string
    subMerchantoid: string
    rt: string
    reMail: string
}

export const usePayment = () => {

    const openInicisReceipt = (params: ReceiptParams) => {

        const popupWidth = 500
        const popupHeight = 800

        const left = window.screenLeft + (window.outerWidth / 2) - (popupWidth / 2)
        const top = window.screenTop + (window.outerHeight / 2) - (popupHeight / 2)
        const popupName = 'inicisReceiptPopup'
        const windowFeatures = `width=${popupWidth}, height=${popupHeight}, left=${left}, top=${top}, resizable=yes, scrollbars=yes`
        const url = "https://iniweb.inicis.com/receipt/iniReceipt.jsp?noTid=" + params.tid

        // 팝업생성
        const receiptWin = window.open(url, popupName, windowFeatures)
    
        // 폼생성 - submit 바로이동 - 이니시스 팝업 동기화 이슈로 이니시스 매뉴얼대로 처리
        // const form = document.createElement("form")
        // form.method = "POST"
        // form.action = "https://iniweb.inicis.com/receipt/SalesSlipReceipt.jsp"
        // form.target = popupName
    
        // Object.entries(params).forEach(([key, value]) => {
        //     const input = document.createElement("input")
        //     input.type = "hidden"
        //     input.name = key
        //     input.value = value
        //     form.appendChild(input)
        // })
    
        // document.body.appendChild(form)
        // form.submit()
        // document.body.removeChild(form)
    }

    return {
        openInicisReceipt
    }
}
